<template>
  <vs-popup
    class="more-links-dialog"
    :title="$t('more_links')"
    :active.sync="isDialogShow"
  >
    <div class="dialog-content">
      <div
        v-for="(item, index) in linkList"
        :key="index"
        class="link-item-wrapper"
      >
        <div class="link-text-wrapper">
          <el-tooltip :content="item" popper-class="popup-tooltip" placement="top">
            <div class="link-text">{{item}}</div>
          </el-tooltip>
          <el-button type="primary" size="small" @click="copyHandle(item)">{{$t('copy_link')}}</el-button>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import copy from 'copy-to-clipboard';

export default {
  name: 'MoreLinksDialog',
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    linkList: {
      type: Array,
      default: () => []
    },
    linkType: {
      type: String,
      default: 'guest' // 'guest' or 'subib'
    }
  },
  data() {
    return {
      isDialogShow: this.dialogShow
    }
  },
  watch: {
    dialogShow(newVal) {
      this.isDialogShow = newVal
    },
    isDialogShow(newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  methods: {
    closeHandle() {
      this.isDialogShow = false
    },
    copyHandle(text) {
      copy(text)
      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess')
      })
    }
  }
}
</script>

<style lang="scss">
.more-links-dialog {
  .vs-popup {
    width: 800px;
    max-width: 95vw;
  }
  
  .dialog-content {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
    
    .link-item-wrapper {
      margin-bottom: 20px;
      padding: 0px;
      background: #F8F8F8;
      border-radius: 10px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .link-text-wrapper {
        display: flex;
        align-items: center;
        border-radius: 10px 40px 40px 10px;
        background: #F8F8F8;
        padding: 4px 12px;
        padding-right: 0;
        margin-right: 0;
        flex: 1;
        min-width: 0;
        max-width: 100%;
        
        .link-text {
          flex: 1;
          font-size: 14px;
          color: #333333;
          margin-right: 15px;
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      .el-button--small {
          border-radius: 18px;
      }
      .invite-code {
        font-size: 14px;
        color: #333333;
        border-radius: 18px;
        background: rgba(254, 89, 36, 0.04);
        padding: 5px 15px;
        display: inline-block;
        
        i {
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
